<template>
  <div class="Heatmap">
    <div class="Heatmap-inner">
      <div class="HeatmapTitle">Search results</div>
      <!-- 表单搜索区 -->
      <el-form ref="form1" class="Heatmap_form" :inline="true" :model="heatmap_form">
        <el-form-item label="Species">
          <el-select size="large" v-model="heatmap_form.specie" @change="heatmapChange" placeholder="Choose">
            <el-option v-for="(item, index) in heatSpacieOptions" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Tissue">
          <el-select size="large" clearable v-model="heatmap_form.tissue" placeholder="Choose">
            <el-option v-for="(item, index) in TissueOptions" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button class="btnSearch" @click="search">Go</el-button>
      </el-form>
      <i class="el-icon-download" style="padding-bottom:14px;" @click="DownloadTableTxt"> Download TXT</i>
      <!-- 多级表格 -->
      <el-table :data="tableData" class="table" v-loading="loading" ref="multipleTable" stripe header-cell-class-name="table-header"
        :header-cell-style="headerStyle" :row-style="rowStyle" @cell-click="handlecell" :cell-style="cellstyle" border>
        <el-table-column :width="idColumnWidth" prop="LncRNA_ID" align="center" fixed="left" :show-overflow-tooltip="true" label="lncRNA ID">
        </el-table-column>
        <el-table-column :label="items.label" align="center" v-for="(items, indexs) in tableDataItem" :key="indexs">
          <el-table-column v-if="item !=='LncRNA_ID'" v-for="(item, index) in items.column" :width="columnWidth" :key="index" :prop="item.prop"
            align="center" :show-overflow-tooltip="true" :label="item.label">
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
          :page-sizes="[10, 20, 30, 50]" :page-size="query.size" layout="total, sizes, prev, pager, next" :total="pageTotal">
        </el-pagination>
      </div>
      <!-- 热力图 -->
      <div style="width: 1200px; margin: 40px auto;" v-loading="imgLoading">
        <div v-for="(item, index) in imgUrlItems" :key="index">
          <p class="keyword_p1">{{item.label}}
            <i class="el-icon-download" @click="DownloadSvg(item.cluster_url)"> Download SVG</i>
          </p>
          <img :src="item.cluster_url" alt="" width='1200px'>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let url = {
  specie_tissue: "species/heatmap_tissue",
  heatmap_specie_tissue: "species/heatmap_specie_tissue",
  specie_name_heatmap: "species/specie_name_heatmap",
  heatmap_cluster_tissue: "species/heatmap_cluster_tissue", //heat map 聚类矢量图接口
};
export default {
  data() {
    return {
      // 表格
      tableDataItem: [],
      tableData: [],
      loading: false,
      pageTotal: 0,
      query: {
        page: 1,
        size: 10
      },
      headerStyle: {
        background: "#F5F9FC",
        fontSize: "16px",
        fontFamily: "PingFang SC",
        fontWeight: "bold",
        color: "#333"
      },
      rowStyle: {
        fontSize: "14px",
        fontFamily: "PingFang SC",
        fontWeight: "400",
        color: "#666"
      },
      // 表单
      heatmap_form: {
        specie: '',
        tissue: ''
      },
      imgUrlItems: [],
      heatSpacieOptions: [],
      TissueOptions: [],
      columnWidth: 120,
      idColumnWidth: 160,
      imgLoading: false
    };
  },
  mounted() {
    this.heatSpecie_all()
    this.getData('跳转')
    this.svgData('跳转')
  },
  methods: {
    // 表格
    getData(val) {
      let params = {}
      if (val == '跳转') {
        let tableParams = JSON.parse(sessionStorage.getItem("tableParams"))
        params = Object.assign({}, tableParams.params, this.query)
        this.heatmap_form.specie = tableParams.params.specie
        this.heatmap_form.tissue = tableParams.params.tissue
      } else {
        params = Object.assign({}, this.heatmap_form, this.query)
      }
      this.loading = true
      this.tableDataItem = []
      this.http.get('species/specie_theatmap_tissue_sra_study', params).then(res => {
        if (res.data.code == 200) {
          this.loading = false
          // debugger
          let count = 1
          res.data.header.forEach((items, index) => {
            this.tableDataItem.push({
              label: items.sra_study,
              column: []
            })
            items.columns_values.forEach(item => {
              if (item != 'LncRNA_ID') {
                this.tableDataItem[index].column.push({
                  prop: item,
                  label: item.split('_')[item.split('_').length - 1]
                })
                count++
              }
            })
            // item.label = item.label.replace(/_/g, ' ');
          })
          // this.tableDataItem = res.data.header
          if (count > 9) {
            this.columnWidth = 120
            this.idColumnWidth = 160
          } else {
            this.columnWidth = 'auto'
            this.idColumnWidth = 'auto'
          }
          // debugger
          this.tableData = res.data.data
          this.pageTotal = res.data.all_count;
        }
      }).catch(err => {
        this.$message.warning(err.response.data.error.message);
      });
    },
    handleSizeChange(val) {
      this.query.page = 1
      this.query.size = val
      this.getData()

    },
    handleCurrentChange(val) {
      this.query.page = val
      this.getData()
    },
    handlecell(row, col) {
      if (col.label === "lncRNA ID") {
        sessionStorage.removeItem("lncRNA_id");
        sessionStorage.setItem("lncRNA_id", row.LncRNA_ID);
        // this.$router.push("/nunMir");
        this.$router.push({
          path: '/nunMir',
          query: {
            plncdb_id: row.LncRNA_ID
          }
        })
      }
    },
    cellstyle({ row, column, rowIndex, columnIndex }) {
      if (column.label === 'lncRNA ID') {
        return { color: "#3366CC", cursor: "pointer" }
      }
      if (column.label === 'Species') {
        return {
          fontStyle: 'italic'
        }
      }
    },
    // 表单
    heatSpecie_all() {
      this.http.get(url.specie_name_heatmap, {}).then((res) => {
        if (res.data.code == 200) {
          this.heatSpacieOptions = res.data.data;
          // this.heatmap_form.specie = res.data.data[0].value
          this.getTissueOptions()
        }
      }).catch((err) => {
        this.$message.warning(err.response.data.error.message);
      });
    },
    heatmapChange() {
      this.getTissueOptions()
      this.heatmap_form.tissue = ''
      this.TissueOptions = []
    },
    getTissueOptions() {
      let params = {
        specie: this.heatmap_form.specie
      }
      this.http.get(url.specie_tissue, params).then((res) => {
        if (res.data.code == 200) {
          this.TissueOptions = res.data.data;
          // this.heatmap_form.tissue = res.data.data[0]
        }
      }).catch((err) => {
        this.$message.warning(err.data.msg);
      });
    },
    svgData(val) {
      let params = {}
      if (val == '跳转') {
        let tableParams = JSON.parse(sessionStorage.getItem("tableParams"))
        params = tableParams.params
        this.heatmap_form.specie = tableParams.params.specie
        this.heatmap_form.tissue = tableParams.params.tissue
      } else {
        params = this.heatmap_form
      }
      this.imgLoading = true
      this.http.get(url.heatmap_cluster_tissue, params).then((res) => {
        if (res.data.code == 200) {
          this.imgUrlItems = res.data.data
          this.imgLoading = false
        }
      }).catch((err) => {
        this.$message.warning(err.data.msg);
      });
    },
    search() {
      this.svgData()
      this.getData()
    },
    DownloadSvg(downloadUrl) {
      const param = {
        cluster_url: downloadUrl,
        tag: 'svg'
      }
      this.jg_downloadFile('species/download_svg_heatmap', param)
    },
    DownloadTableTxt() {
      const param = {
        specie: this.heatmap_form.specie,
        tissue: this.heatmap_form.tissue,
        tag: 'txt'
      }
      this.jg_downloadFile('species/specie_download_heatmap_tissue', param)
    }
  }
};
</script>

<style scoped>
.Heatmap {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.Heatmap .Heatmap-inner {
  width: 1240px;
  height: auto;
  padding: 0px 20px;
  padding-bottom: 20px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
}
.Heatmap .Heatmap-inner .HeatmapTitle {
  height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 50px;
  border-bottom: 1px solid rgba(229, 233, 235, 1);
  margin-bottom: 20px;
}
.svgClass {
  margin-top: 20px;
  width: 100%;
  height: 750px;
  /* height: 916px; */
}
.btnSearch {
  width: auto;
  height: 40px;
  background: rgba(139, 182, 68, 1);
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fff;
  outline: none;
  border: none;
  margin-left: 15px;
}
.Heatmap_form >>> .el-form-item__label {
  /* width:100px; */
  height: 40px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333;
  line-height: 40px;
}
.el-pagination {
  /* float: right; */
  text-align: right;
  height: 20px;
  margin: 20px 0;
}
.keyword_p1 {
  margin-top: 30px;
  margin-bottom: 0;
  height: 47px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.el-icon-download {
  float: right;
  color: rgb(139, 182, 68);
  font-size: 14px;
  cursor: pointer;
  padding-top: 8px;
  padding-left: 20px;
}
</style>
